import { Col as AntdCol } from "antd";
import React, { ReactNode } from "react";
import { ColProps as AntdColProps } from "antd/es/grid/col";

export interface MyColProps extends AntdColProps {
  children?: ReactNode;
}

const ColPolyfill: React.FC<MyColProps> = ({ children, ...props }) => {
  return <AntdCol {...props}>{children}</AntdCol>;
};

export default ColPolyfill;
